import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '../components/Auth/AuthLayout'
import http from '../config/http'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async event => {
    event.preventDefault()
    setSaving(true)
    try {
      const { data } = await http.post('/api/users/forgot-password', { email })
      setMessage(data.message)
    } catch (error) {
      setMessage(error.userMessage || 'Unable to request a password reset.')
    } finally { setSaving(false) }
  }

  return <AuthLayout><div className="rounded-2xl bg-white p-8 shadow-sm"><h1 className="text-2xl font-bold text-gray-900">Reset your password</h1><p className="mt-2 text-sm text-gray-500">Enter your account email. The reset link is valid for 30 minutes.</p>{message ? <div className="mt-6 rounded-lg bg-violet-50 p-4 text-sm text-violet-800">{message}</div> : <form onSubmit={submit} className="mt-6 space-y-4"><label className="block text-sm font-medium text-gray-700">Email<input required type="email" value={email} onChange={event => setEmail(event.target.value)} className="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2.5" /></label><button disabled={saving} className="w-full rounded-lg bg-violet-700 px-4 py-2.5 font-medium text-white disabled:opacity-50">{saving ? 'Sending…' : 'Send reset link'}</button></form>}<Link to="/login" className="mt-6 inline-block text-sm font-medium text-violet-700">Back to login</Link></div></AuthLayout>
}
